export default "__VITE_PUBLIC_ASSET__17412db9__"